const place_list_button = {
  confirm: 'Esse ramo possui',
  confirm1: 'equipamentos no total. Deseja gerar todos os qr codes desse ramo?',
  title: 'GERAR QRCODE',
  else: 'Este ramo não possui nenhum equipamento. Adicione os equipamentos nas folhas deste ramo e depois imprima os qr codes.'
};

export default place_list_button;
